<template>
  <div class="bg-white">
    <h2 class="font-bold text-3xl">Tính giá điện</h2>

    <p class="mt-2">Tính giá điện dựa trên số lượng điện sử dụng</p>

    <div class="w-full max-w-xs">
      <input
        v-model="input"
        type="number"
        min="0"
        max="999999"
        class="mt-1
              block
              w-full
              rounded-md
              border-gray-300
              shadow-sm
              focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
        placeholder="số điện"
        autofocus
      />
    </div>

    <template v-if="total">
      <p class="mt-5">
        Tổng số tiền phải trả: <strong>{{ total }}</strong> đồng
        <br>
        Lưu ý: kết quả chỉ mang tính tham khảo.
      </p>

      <p class="mt-5"><strong>Chi tiết</strong></p>

      <table class="table-fixed w-full table-hover table-focus">
        <thead>
          <tr>
            <th class="w-1/2 px-4 py-2">Bậc</th>
            <th class="text-right w-1/6 px-4 py-2">Đơn giá</th>
            <th class="text-right w-1/6 px-4 py-2">Số lượng</th>
            <th class="text-right w-1/6 px-4 py-2">Thành tiền (₫)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="level_1">
            <td class="border px-4 py-2">Bậc 1 (0 - 50)</td>
            <td class="text-right border px-4 py-2">{{ level_1_price }}</td>
            <td class="text-right border px-4 py-2">{{ level_1_number }}</td>
            <td class="text-right border px-4 py-2">{{ level_1_formatted }}</td>
          </tr>
          <tr v-if="level_2" class="bg-gray-100">
            <td class="border px-4 py-2">Bậc 2 (51 - 100)</td>
            <td class="text-right border px-4 py-2">{{ level_2_price }}</td>
            <td class="text-right border px-4 py-2">{{ level_2_number }}</td>
            <td class="text-right border px-4 py-2">{{ level_2_formatted }}</td>
          </tr>
          <tr v-if="level_3">
            <td class="border px-4 py-2">Bậc 3 (101 - 200)</td>
            <td class="text-right border px-4 py-2">{{ level_3_price }}</td>
            <td class="text-right border px-4 py-2">{{ level_3_number }}</td>
            <td class="text-right border px-4 py-2">{{ level_3_formatted }}</td>
          </tr>
          <tr v-if="level_4" class="bg-gray-100">
            <td class="border px-4 py-2">Bậc 4 (201 - 300)</td>
            <td class="text-right border px-4 py-2">{{ level_4_price }}</td>
            <td class="text-right border px-4 py-2">{{ level_4_number }}</td>
            <td class="text-right border px-4 py-2">{{ level_4_formatted }}</td>
          </tr>
          <tr v-if="level_5">
            <td class="border px-4 py-2">Bậc 5 (301 - 400)</td>
            <td class="text-right border px-4 py-2">{{ level_5_price }}</td>
            <td class="text-right border px-4 py-2">{{ level_5_number }}</td>
            <td class="text-right border px-4 py-2">{{ level_5_formatted }}</td>
          </tr>
          <tr v-if="level_6" class="bg-gray-100">
            <td class="border px-4 py-2">Bậc 6 (401+ )</td>
            <td class="text-right border px-4 py-2">{{ level_6_price }}</td>
            <td class="text-right border px-4 py-2">{{ level_6_number }}</td>
            <td class="text-right border px-4 py-2">{{ level_6_formatted }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="2" class="text-right px-4 py-2">Tổng điện năng tiêu thụ</td>
            <td class="text-right px-4 py-2">{{ input }}</td>
            <td class="text-right px-4 py-2">{{ subtotal_formatted }}</td>
          </tr>
          <tr>
            <td colspan="2" class="text-right px-4 py-2">Thuế GTGT (10%)</td>
            <td class="text-right px-4 py-2"></td>
            <td class="text-right px-4 py-2">{{ vat_formatted }}</td>
          </tr>
          <tr>
            <td colspan="2" class="text-right px-4 py-2"><strong>Tổng cộng</strong></td>
            <td class="text-right px-4 py-2 border-top"></td>
            <td class="text-right px-4 py-2 border-top">{{ total }}</td>
          </tr>
        </tfoot>
      </table>
    </template>

    <div class="bg-blue-100 border-l-4 border-blue-500 text-blue-700 p-4 mt-5" role="alert">
      <p class="font-bold m-0">Tham khảo</p>
      <p class="m-0"><a href="https://www.evn.com.vn/c3/evn-va-khach-hang/Bieu-gia-ban-le-dien-9-79.aspx"
            class="text-blue-600 underline">
            Biểu giá bán lẻ điện
          </a></p>
    </div>
  </div>
</template>

<script>
const formatter = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' })

export default {
  data () {
    return {
      input: null,
      level_1_price: 1678,
      level_2_price: 1734,
      level_3_price: 2014,
      level_4_price: 2536,
      level_5_price: 2834,
      level_6_price: 2927,
    }
  },
  computed: {
    level () {
      if (this.input)
        if (this.input <= 50)
          return 1
        else if (this.input <= 100)
          return 2
        else if (this.input <= 200)
          return 3
        else if (this.input <= 300)
          return 4
        else if (this.input <= 400)
          return 5
        else
          return 6
    },
    level_1_number () {
      if (this.level > 1)
        return 50
      if (this.level == 1)
        return this.input
    },
    level_2_number () {
      if (this.level == 2)
        return (this.input - 50)
      if (this.level > 2)
        return 50
    },
    level_3_number () {
      if (this.level == 3)
        return (this.input - 100)
      if (this.level > 3)
        return 100
    },
    level_4_number () {
      if (this.level == 4)
        return (this.input - 200)
      if (this.level > 4)
        return 100
    },
    level_5_number () {
      if (this.level == 5)
        return (this.input - 300)
      if (this.level > 5)
        return 100
    },
    level_6_number () {
      if (this.level == 6)
        return (this.input - 400)
    },
    level_1 () {
      return this.level_1_number * this.level_1_price
    },
    level_2 () {
      return this.level_2_number * this.level_2_price
    },
    level_3 () {
      return this.level_3_number * this.level_3_price
    },
    level_4 () {
      return this.level_4_number * this.level_4_price
    },
    level_5 () {
      return this.level_5_number * this.level_5_price
    },
    level_6 () {
      return this.level_6_number * this.level_6_price
    },
    level_1_formatted () {
      return formatter.format(this.level_1)
    },
    level_2_formatted () {
      return formatter.format(this.level_2)
    },
    level_3_formatted () {
      return formatter.format(this.level_3)
    },
    level_4_formatted () {
      return formatter.format(this.level_4)
    },
    level_5_formatted () {
      return formatter.format(this.level_5)
    },
    level_6_formatted () {
      return formatter.format(this.level_6)
    },
    subtotal () {
      switch (this.level) {
        case 1:
          return this.level_1
        case 2:
          return this.level_1 + this.level_2
        case 3:
          return this.level_1 + this.level_2 + this.level_3
        case 4:
          return this.level_1 + this.level_2 + this.level_3 + this.level_4
        case 5:
          return this.level_1 + this.level_2 + this.level_3 + this.level_4 + this.level_5
        case 6:
          return this.level_1 + this.level_2 + this.level_3 + this.level_4 + this.level_5 + this.level_6
      }
    },
    vat () {
      if (this.subtotal)
        return this.subtotal * 0.1
    },
    total () {
      if (this.subtotal)
        return formatter.format(this.subtotal + this.vat)
    },
    subtotal_formatted () {
      if (this.subtotal)
        return formatter.format(this.subtotal)
    },
    vat_formatted () {
      if (this.vat)
        return formatter.format(this.vat)
    },
  }
}
</script>
